"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FetchClientGet = exports.HttpError = exports.getApiGatewayHeaders = exports.AtoZClientId = void 0;
var AtoZClientId;
(function (AtoZClientId) {
    AtoZClientId["ATOZ_PRE_HIRE"] = "ATOZ_PRE_HIRE";
})(AtoZClientId = exports.AtoZClientId || (exports.AtoZClientId = {}));
const getApiGatewayHeaders = (clientId, authHeaders) => (Object.assign({ 'x-atoz-client-id': clientId, 'Content-Type': 'application/json' }, authHeaders));
exports.getApiGatewayHeaders = getApiGatewayHeaders;
class HttpError extends Error {
    constructor(statusCode, message) {
        super(message);
        this.statusCode = statusCode;
    }
}
exports.HttpError = HttpError;
/**
 * Use this method for fetching (GET) data to AtoZ API delegator vended endpoint, i.e:
 * https://atoz-api.integ.amazon.com or https://atoz-api.amazon.work
 */
const FetchClientGet = (url, clientId, authenticatedRequestHeaders, telemetry) => __awaiter(void 0, void 0, void 0, function* () {
    const span = telemetry === null || telemetry === void 0 ? void 0 : telemetry.tracer.startSpan('FetchClient');
    span === null || span === void 0 ? void 0 : span.setAttribute('http.method', 'GET');
    span === null || span === void 0 ? void 0 : span.setAttribute('http.url', url);
    try {
        const authHeaders = yield authenticatedRequestHeaders();
        const response = yield fetch(url, {
            method: 'GET',
            headers: (0, exports.getApiGatewayHeaders)(clientId, authHeaders),
            credentials: 'include',
        });
        span === null || span === void 0 ? void 0 : span.setAttribute('status', JSON.stringify({
            code: response.status,
            message: response.statusText,
        }));
        span === null || span === void 0 ? void 0 : span.end();
        if (!response.ok) {
            const responseText = yield response.text();
            throw new HttpError(response.status, responseText);
        }
        return yield response.json();
    }
    catch (e) {
        span === null || span === void 0 ? void 0 : span.end();
        throw e;
    }
});
exports.FetchClientGet = FetchClientGet;
//# sourceMappingURL=fetchClient.js.map